const PAYMENT_GATEWAYS = {
  Pumb: { name: "Pumb", id: "Pumb" },
  NovaPay: { name: "NovaPay", id: "NovaPay" },
  Monobank: { name: "Monobank", id: "Monobank" },
  LiqPay: { name: "LiqPay", id: "LiqPay" },
};

export default PAYMENT_GATEWAYS;
